import Plugin from './index';
import lifecycle from 'page-lifecycle';
import store from '../../../store';

// 页面隐藏时限，超过时限直接上报
const PAGE_HIDDEN_TIME = 10 * 60 * 1000;
// 页面最短停留时长
const MIN_DURATION = 1000;
// 页面最长停留时长
const MAX_DURATION = 30 * 60 * 1000;

class PageDurationPlugin extends Plugin {
  name = 'pageDuration';

  // 上报的页面地址
  private reportPath = '';
  // 进入页面时间
  private startTime = 0;
  // 暂存的停留时长
  private stashDuration = 0;
  // 页面隐藏计时器
  private timer = 0;

  init() {
    const { enableReport } = store.config;
    if (enableReport) {
      // 页面状态改变时上报停留时长
      // 页面生命周期： https://developer.chrome.com/blog/page-lifecycle-api/
      lifecycle.addEventListener('statechange', (e: any) => {
        if (e.oldState === 'active' && e.newState === 'passive') {
          // 页面隐藏时，暂时保存停留时长
          this.stashSave();
        } else if (e.oldState === 'passive' && e.newState === 'active') {
          // 重新进入页面时，恢复页面
          this.stashPop();
        } else if (e.newState === 'terminated' || e.newState === 'discarded') {
          // 页面终止或被丢弃时，如果有停留时长则上报
          if (this.stashDuration) {
            this.reportDuration();
          }
        }
      });
    }
  }

  // 页面改变时上报停留时长
  onPageChange() {
    const { enableReport } = store.config;
    if (enableReport) {
      this.reportDuration();
    }
  }

  // 上报停留时长
  reportDuration() {
    // 首次进入页面时设置url和进入时间
    if (!this.reportPath) {
      this.resetDuration();
      return;
    }
    const duration = (this.startTime ? new Date().getTime() - this.startTime : 0) + this.stashDuration;
    const reportData = {
      action: 'page-duration',
      path: this.reportPath,
      duration,
    };

    this.resetDuration();

    // 停留时长过长过短时不上报
    if (duration < MIN_DURATION || duration > MAX_DURATION) {
      return;
    }

    this.instance.reportAction(reportData);
  }

  // 重置页面时长
  resetDuration() {
    this.reportPath = store.getPathname();
    this.startTime = new Date().getTime();
    this.stashDuration = 0;
    this.clearTimer();
  }

  // 离开页面时，保存页面停留时长
  private stashSave() {
    if (!this.startTime) {
      return;
    }
    this.stashDuration += new Date().getTime() - this.startTime;
    this.startTime = 0;
    this.timer = window.setTimeout(() => {
      this.reportDuration();
    }, PAGE_HIDDEN_TIME);
  }

  // 重新进入页面时，重置页面开始时间
  private stashPop() {
    this.reportPath = store.getPathname();
    this.startTime = new Date().getTime();
    this.clearTimer();
  }

  private clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = 0;
    }
  }
}

export default PageDurationPlugin;
